import { useCallback, useMemo } from "react"

import { useMatch, useRoutes } from "react-router-dom"

import { CatalogItemLayers } from "@l2r-front/l2r-common"
import { ImageCollectionLayer, ImageSelectedLayer, useImageCollectionDispatchContext } from "@l2r-front/l2r-images"
import { NetworkReferentialLayer, useNavigateToLinearLocation, useNetworksDispatchContext } from "@l2r-front/l2r-networks"

import { APP_CITY } from "../../../../common/constants/appCity"
import { MODULE_VERTICAL_SIGNING } from "../../../../common/constants/modules"
import { DETAIL_TAB_PARAM_KEY } from "../../../../common/constants/tabKeys"
import { VerticalSignPolesSource } from "../../containers/VerticalSignPolesSource"

import { VerticalSignPoleValidator } from "../VerticalSignPoleValidator"

export function VerticalSigningMapLayersRouter() {

    const matchRoad = useMatch(`:slugId/${APP_CITY}/${MODULE_VERTICAL_SIGNING}/:road/*`)
    const matchCode = useMatch(`:slugId/${APP_CITY}/${MODULE_VERTICAL_SIGNING}/code/:code/*`)
    const matchRoadCode = useMatch(`:slugId/${APP_CITY}/${MODULE_VERTICAL_SIGNING}/:road/code/:code/*`)

    const road = matchRoad?.params?.road ? decodeURIComponent(matchRoad.params.road) : null
    const isSegmentView = !!matchRoad && road !== "code"

    const navigateToLinearLocation = useNavigateToLinearLocation()
    const { setSegmentFeatureIdClicked } = useImageCollectionDispatchContext()
    const { setSelectedLinearLocations } = useNetworksDispatchContext()

    const processNavigation = useCallback((feature, location, navigationOrigin) => {
        if (location && location.road && location.road !== road) {
            setSegmentFeatureIdClicked(feature?.properties?.uuid)
            setSelectedLinearLocations(feature)
            const newUrlEnd = (matchCode || matchRoadCode) ? `code/${(matchCode || matchRoadCode).params.code}` : null
            navigateToLinearLocation(location, ".", { urlEnd: newUrlEnd, saveMapBoundingBox: !isSegmentView, navigationOrigin: navigationOrigin })
        }
    }, [matchCode, matchRoadCode, setSegmentFeatureIdClicked, setSelectedLinearLocations, navigateToLinearLocation, isSegmentView, road])

    const layers = useMemo(() => {
        return (
            <>
                <NetworkReferentialLayer processNavigation={processNavigation} />
                <CatalogItemLayers Source={VerticalSignPolesSource} paramsToDeleteOnClick={[DETAIL_TAB_PARAM_KEY]} />
                {isSegmentView && <ImageCollectionLayer road={road} />}
                {isSegmentView && <ImageSelectedLayer />}
            </>
        )
    }, [isSegmentView, processNavigation, road])

    const layersRoutes = useMemo(() => ([
        { path: "/*", element: layers },
        { path: "/code/:code", element: layers },
        { path: "/:road", element: layers },
        { path: "/:road/code/:code", element: layers },
        { path: "/:road/:signId", element: <VerticalSignPoleValidator>{layers}</VerticalSignPoleValidator> },
        { path: "/:road/code/:code/:signId", element: <VerticalSignPoleValidator>{layers}</VerticalSignPoleValidator> },
    ]), [layers])

    return useRoutes(layersRoutes)
}